<template>
  <div class="paypal-verify" redesign>
    <!-- Request stepper -->
    <!--<RequestStepProgressBar v-if="!currentRequest.isReproductiveRightsRequest" isPaypalVerify />-->

    <Stepper
        v-if="currentRequest.isReproductiveRightsRequest"
        stepInfo="Step 1 of 4"
        description="Make sure you can receive money"
      />

    <div class="paypal-verify-form form-container">
      <LoadSpinner v-if="pageLoading" :color="`#${organizationDetails.darkBrandColor}`" />

      <template v-else>
        <div v-if="Object.keys(currentWiseProfile).length > 0" class="details-container">
          <h4 class="form-field-header">Your currently active payout account</h4>
          <span class="details">Name: {{currentWiseProfile.accountHolderName}}</span>
          <span class="details">Payout Currency: {{currentWiseProfile.currency}}</span>
          <span v-if="currentWiseProfile.details.abartn" class="details">Routing Number: {{currentWiseProfile.details.abartn && currentWiseProfile.details.abartn}}</span>
          <span v-if="currentWiseProfile.details.bic" class="details">Swift/BIC Number: {{currentWiseProfile.details.bic && currentWiseProfile.details.bic}}</span>
          <span class="details">Last 4 of Account Number: {{currentWiseProfile.details.accountNumber && currentWiseProfile.details.accountNumber.slice(-4)}}</span>
        </div>

        <div v-if="Object.keys(currentWiseProfile).length === 0 || createNewAccount === true">
          <div class="form-field required">
            <h4 class="form-field-header">What currency would you like to receive your payout in?</h4>
            <select v-if="currencyOptions" v-model="selectedCurrency" @change="selectCurrency">
              <option v-for="(option, index) in currencyOptions" :key="option.title" :value="option.currencyCode">
                {{ option.currencyCode }}
              </option>
            </select>
            <span class="form-dropdown" />
          </div>

          <LoadSpinner v-if="wiseOptionsLoading" :color="`#${organizationDetails.darkBrandColor}`" />

          <div v-if="wiseOptions && !wiseOptionsLoading" class="form-field required">
            <h4 class="form-field-header">How would you like to receive your payout?</h4>
            <select @change="selectWise">
              <option v-for="(option, index) in wiseOptions" :key="option.title" :value="index">
                {{ option.title }}
              </option>
            </select>
            <span class="form-dropdown" />
            <div v-if="wiseOptions"> {{ this.wiseOptions[this.wiseOption] && this.wiseOptions[this.wiseOption]['usageInfo'] }} </div>
          </div>



          <div v-if="formFields.fields.length > 0" v-for="superField in formFields.fields">
            <div v-for="field in superField.group">
              <div v-if="field.type === 'select' || field.type === 'radio'">
                <div class="form-field">
                  <h4 class="form-field-header">{{ field.name }}</h4>
                  <select @change="(event) => formValue(event, field.key)">
                    <option
                      v-for="allowedValue in field.valuesAllowed"
                      :key="allowedValue.key"
                      :value="allowedValue.key"
                    >
                      {{ allowedValue.name }}
                    </option>
                  </select>
                  <span class="form-dropdown" />
                </div>
              </div>

              <div v-if="field.type === 'text'">
                <FormTextField
                    :label="field.name"
                    :required="field.required"
                    :value.sync="filledForm[field.key]"
                    :helpText="field.example"
                />
              </div>
            </div>
          </div>

          <!-- No emergency error -->
          <div v-if="displayError" class="form-field error-container">
            <div class="tooltip-icon">
              <img src="@/assets/icons/error-icon.png" />
            </div>
            <div class="tooltip">
              <h4 class="tooltip-header" v-translate>There are errors setting up your payout</h4>
              <div v-for="error in errors">
                <span class="tooltip-text">
                  {{ error.message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-footer">
          <div class="button-container">
            <button class="form-button white-button" :class="{ 'form-button-160' : !isAddPaymentMethod }" @click="$emit('go-back')" v-if="multiplePayoutMethods">
              {{ isAddPaymentMethod ? $gettext('Select Another Method') : $gettext('Go Back') }}
            </button>

            <SubmitButton v-if="!multiplePayoutMethods && !isAddPaymentMethod" :whiteButton="true" :buttonText="$gettext('Skip For Now')" :staticWidth="true" class="skip-button" />

            <!-- Submit -->
            <SubmitButton
              v-if="!isAddPaymentMethod"
              :loading="pageLoading"
              :onContinue="validate"
              :staticWidth="true"
            />
            <button class="form-button" @click="validate" v-else>{{ $gettext('Add Payment Method') }}</button>
          </div>
          <div class="form-footer skip-for-now" v-if="!isAddPaymentMethod">
            <span>OR</span>
            <SubmitButton :buttonText="$gettext('Skip For Now')" :darkButton="true" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Employee from '@/services/employees'
import LoadSpinner from '@/components/LoadSpinner'
import InfoBox from '@/components/InfoBox'
//import Field from '../components/Field'
import { objectToCamelCase } from '@/services/utils'
import { analyticsMixin } from '@/services/googleAnalytics'
import RequestStepProgressBar from '@/components/stepper/RequestStepProgressBar'
import FormTextField from '@/components/forms/FormTextField'
import {API_BASE, apiErrorHandler, ApiFilter, isDefinedAndNotNull, isNotEmpty} from '@/services/api'
import Auth from '@/services/auth'
import SubmitButton from '@/components/requests/SubmitButton'
import {wiseRequestOptions, wiseFormEndpoint} from '@/services/wise'
import axios from 'axios'
import Stepper from '@/components/requests/Stepper'

export default {
  name: 'WisePayment',
  mixins: [analyticsMixin],
  components: {
    LoadSpinner,
    InfoBox,
    //Field,
    RequestStepProgressBar,
    FormTextField,
    SubmitButton,
    Stepper,
  },
  data() {
    return {
      pageLoading: true,
      loading: false,
      displayError: false,
      currentWiseProfile: {},
      wiseOptions: [],
      wiseCurrencyOptions: {},
      currencyOptions: [],
      selectedCurrency: "",
      wiseOption: 0,
      quoteId: '',
      transferId: '',
      formFields: [],
      filledForm: {},
      errors: [],
    }
  },
  props: {
    isAddPaymentMethod: {
      type: Boolean,
      required: false,
    },
    multiplePayoutMethods: {
      type: Boolean,
      required: false,
    },
  },
  async created() {
    // Re-fetch employee data
    await this.updateUser()
    this.selectedCurrency = "USD"
    this.filledForm["currency"] ="USD"
    await this.getCurrencyInformationForWise({ target: { value: "USD" } })
    this.selectCurrency({ target: { value: "USD" } })

    this.pageLoading = false
  },
  methods: {
    async updateUser() {
      const employee = await Employee.api.retrieve(this.user.id)
      if (employee.wiseAccountId) {
        const wiseProfile = await this.getProfileInformationForWise(employee.wiseAccountId)
        this.currentWiseProfile = wiseProfile
      }

      this.$store.dispatch('updateUser', employee)
      this.paypalEmail = employee.paypalEmail
    },
    formValue(event, title) {
      this.filledForm[title] = event.target.value

      this.getUpdatedWiseRequirements()
    },
    async validate() {
      if (this.user.wiseAccountId) {
        return true
      } else {
        await this.submitWiseValues()
      }

      if(isAddPaymentMethod)
        this.$router.push({ name: 'Home' })

      Promise.reject("no-wise-account-id")
    },
    async getUpdatedWiseRequirements(selectedCurrency, quoteId) {
      this.loading = true


      this.filledForm['currency'] = this.selectedCurrency
      this.filledForm['quote_id'] = this.quoteId

      const promise = axios
        .post(`${wiseFormEndpoint}update-form/`, this.filledForm, wiseRequestOptions)
          .then(res => {
              this.formFields = res.data[this.wiseOption]
          })
        .catch(apiErrorHandler({apiName: 'PayoutAPI.retrieve'}))
      this.loading = false
      return promise
    },
    async submitWiseValues() {
      this.displayError = false
      this.errors = []
      this.filledForm['currency'] = this.selectedCurrency
      this.filledForm

      const promise = axios
        .post(`${wiseFormEndpoint}create-account/`, this.filledForm, wiseRequestOptions)
        .then(res => {

          if (res.data && res.data.errors && res.data.errors.length > 0) {
            this.displayError = true
            this.errors = res.data.errors
            return Promise.reject('wise-account-errors')
          }

          this.updateUser()
        })
      .catch(error => {
        apiErrorHandler({apiName: 'WiseSetup.create-account'})
        return Promise.reject('wise-account-errors')
      })
      return promise
    },
    async selectCurrency(event) {
      this.loading = true
      this.filledForm['currency'] = event.target.value
      this.selectedCurrency = event.target.value
      await this.getFormInformationForWise(event.target.value)
      this.formFields = this.wiseOptions[0]

      this.filledForm['type'] = this.wiseOptions[0]['type']

      this.formFields.fields.map((field) => {
        if (field.group[0].type === 'select' || field.group[0].type === 'radio') {
          this.filledForm[field.group[0].key] = field.group[0].valuesAllowed[0].key
        }
      })

      this.getUpdatedWiseRequirements()
    },
    selectWise(event) {
      this.wiseOption = event.target.value
      this.formFields = []
      this.formFields = this.wiseOptions[event.target.value]
      this.filledForm = {}
      this.filledForm['type'] = this.wiseOptions[event.target.value]['type']

      this.formFields.fields.map((field) => {
        if (field.group[0].type === 'select' || field.group[0].type === 'radio') {
          this.filledForm[field.group[0].key] = field.group[0].valuesAllowed[0].key
        }
      })

      this.getUpdatedWiseRequirements()
    },
    getCurrencyInformationForWise() {
      const promise = axios
        .get(`${wiseFormEndpoint}get-currency-pairs/`, wiseRequestOptions)
        .then(res => {
            this.wiseCurrencyOptions = res.data
            if (res.data && res.data["error"]) {
              Promise.reject(res.data["error"])
            }
            this.currencyOptions = res.data['sourceCurrencies'].find((option) => option['currencyCode'] === 'USD')['targetCurrencies']
          }
        )
        .catch(apiErrorHandler({apiName: 'PayoutAPI.retrieve'}))

      return promise
    },
    createTransfer() {
      const promise = axios
          .post(`${wiseFormEndpoint}create-transfer/`,
              {
                  "wise_account_id": this.user.wiseAccountId,
                  "quote_id": this.quoteId
              },
              wiseRequestOptions
          )
        .then(res => {
            this.transferId = res.data['id']
          }
        )
        .catch(apiErrorHandler({apiName: 'PayoutAPI.retrieve'}))
      return promise
    },
    fundTransfer() {
      const promise = axios
          .post(`${wiseFormEndpoint}fund-transfer/`,
              {
                  "transfer_id": this.transferId,
              },
              wiseRequestOptions
          )
          .catch(apiErrorHandler({apiName: 'PayoutAPI.retrieve'}))
      return promise
    },
    getTransferRequirements() {
      const promise = axios
          .post(`${wiseFormEndpoint}get-transfer-requirements/`,
              {
                  "wise_account_id": this.user.wiseAccountId,
                  "quote_id": this.quoteId
              },
              wiseRequestOptions
          )
          .catch(apiErrorHandler({apiName: 'PayoutAPI.retrieve'}))
      return promise
    },
    getProfileInformationForWise(profileId) {
      const promise = axios
        .get(`${wiseFormEndpoint}get-profile/?profile_id=${profileId}`, wiseRequestOptions)
        .then(res => {
            return res.data
          }
        )
        .catch(apiErrorHandler({apiName: 'PayoutAPI.retrieve'}))
      return promise
    },
    getFormInformationForWise(currency='USD') {
      const promise = axios
        .get(`${wiseFormEndpoint}get-form/?currency=${currency}`, wiseRequestOptions)
        .then(res => {
            this.wiseOptions = []
            this.quoteId = res.data['quote_id']
            this.wiseOptions = res.data['response']
          }
        )
        .catch(apiErrorHandler({apiName: 'PayoutAPI.retrieve'}))
      return promise
    },
  },
  computed: {
    ...mapState(['user', 'currentRequest', 'organizationDetails']),
    wiseOptionsLoading() {
      if(!this.wiseOptions)
        return false

      return !this.wiseOptions.length
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/responsive';

.details {
  display: block;
}

.details-container {
  border: 1px solid #dfdfe0;
  border-radius: 20px;
  padding: 1.5rem;
  margin: 1rem;
}

.form-field-container {
  display: flex;
}

.form-field-text {
  background: #f4f4f5;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #9e9e9e;
  flex: 1;
  padding: 1rem;
}

.paypal-verify {
  display: flex;
  flex-direction: column;

  .paypal-verify-form {
    @extend .constrain-tablet-and-up;
  }

  .card-shape {
    max-width: 453px;
    width: 100%;
    align-self: center;

    @include tablet-and-up-screen {
      padding: 2.5rem;
    }

    .form-field {
      margin-bottom: 0;
    }
  }

  .button-container {
    display: flex;
    justify-content: center;

    .form-button {
      margin-right: 1rem;
    }
  }

  .skip-for-now {
    text-align:center;

    span {
      display: block;
      font-size: 1.8rem;
      font-weight: bold;
      margin: 1rem 0;
    }

    .form-button {
      padding: 2rem;
    }
  }
}

</style>
